import React, { FunctionComponent, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { pathOr } from 'ramda';
import { Container } from 'semantic-ui-react';
import classnames from 'classnames';
import withStyles from 'react-jss';

import { useUserMgmt } from 'components/UserMgmt/UserMgmt.context';
import { GET_IS_OPEN } from 'components/Header/components/Filters/Filters.queries';

import MerchantSuccessLandingPage from './scenes/MerchantSuccessLandingPage';
import MerchantLandingPage from './scenes/MerchantLandingPage';

import { ClassProp } from 'helpers/types';

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
};

const styles = {
  container: {
    marginTop: '12rem',
    justifyContent: 'center !important',
    '&.filtersIsOpen': {
      marginTop: '17rem !important',
    },
  },
};

const MerchantStatusDetails: FunctionComponent<Props> = ({ classes }) => {
  const { isInternalUser, isExternalUser } = useUserMgmt();
  const isOpenPayload = useQuery(GET_IS_OPEN);

  const filtersIsOpen = pathOr(false, ['data', 'filtersIsOpen'], isOpenPayload);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Container className={classnames(classes.container, { filtersIsOpen })}>
      {isExternalUser && <MerchantLandingPage />}
      {isInternalUser && <MerchantSuccessLandingPage />}
    </Container>
  );
};

export default withStyles(styles)(MerchantStatusDetails);
